import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import { formatMediaUrl } from '../../utils/mediaUrl'
import {
  formatCatchupChannel,
  formatCatchupsProgram,
  getProgramsAndDateListFromProgramsArray,
} from './catchups.format'

export function use(
  client: WbsClient,
  catchups: API['catchups'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  catchups.getChannelsWithCatchupsFx.use(async () => {
    const channels = await payload(client.get.api.v3.channels.tv.catchups())
    return channels
      .map(formatCatchupChannel)
      .sort((a, b) => a.sortOrder - b.sortOrder)
  })

  catchups.getChannelCatchupProgramsFx.use(async ({ channelId, catchupId }) => {
    const programmes = await payload(
      client.get.api.v3.channels.tv(channelId).catchups(catchupId).programmes() // prettier-ignore
    )
    const programsList = programmes.map(formatCatchupsProgram)
    return getProgramsAndDateListFromProgramsArray(programsList)
  })

  catchups.getCatchupUrlFx.use(
    async ({ channelId, catchupId, programmeId }) => {
      const media = await payload(
        client.get.api.v3.channels
          .tv(channelId)
          .catchups(catchupId)
          .programmes(programmeId)
          .url()
      )
      return formatMediaUrl(media)
    }
  )
}
